import { ModelBase } from '../../core/model/model-base';
import { Money } from '../../core/model/money';
import { InvoiceTransaction } from '../../invoice/model/invoice-transaction';

export class RentLoss extends ModelBase {
  period: {
    year: number;
    month: number;
  };
  companyName: number;
  rentalId: string;
  propertyCaption: string;
  vacancyDays: number;
  amount: Money;
  accountingTransactions: InvoiceTransaction[];
  daysDescription: string;
}
